export default __webpack_public_path__ + "static/media/logo.b13d950f.jpeg";